import _ from 'underscore';
import '@bingads-webui/kendo/kendo.autocomplete';
import {data as kendoData} from '@bingads-webui/kendo/kendo.data';
import Backbone from 'backbone';
import Searchbox from '@bingads-webui-component-legacy/searchbox/view/searchbox';
import convert from '@bingads-webui-campaign-legacy/auto-targets/service/convert';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.searchBox = new Searchbox({
      defaultText: i18n.get('DSA_AutoTargets_Searchbox_Placeholder'),
    });
    this.searchBox.on('search', (value) => {
      this.trigger('search', value);
    });
  }

  render() {
    this.$el.append(this.searchBox.render().el);
  }

  load() {
    return this.options.dataSource().then((categories) => {
      this.$('input').kendoAutoComplete({
        dataSource: new kendoData.DataSource({
          serverFiltering: true,
          data: categories,
          schema: {
            parse: (data) => {
              const value = _.result(this.$('input').data('kendoAutoComplete'), 'value');

              if (_.isUndefined(value)) {
                return data;
              } else {
                const pattern = new RegExp(`(^|/)${value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}`, 'i');
                const result = _.filter(data, (item) => {
                  return pattern.test(item.CategoryName);
                });

                // only show first level cateogry if we have more than 100 matches
                if (result.length <= 100) {
                  return result;
                } else {
                  return _.filter(result, (item) => {
                    return !(/\/.+/).test(item.CategoryName);
                  });
                }
              }
            },
          },
        }),
        dataTextField: 'CategoryName',
        highlightFirst: true,
        height: 280,
        template: `<a href='javascript:void(0)'>#: (${convert.singleLine.toString()})(CategoryName) #</a>`,
        select: (e) => {
          const name = e.sender.dataItem(e.item.index()).CategoryName;

          this.searchBox.ko_model.value(name);
          this.trigger('search', name);
        },
      });
      return this;
    });
  }
}
